import React from 'react';
import { Dealer, DealerAttribute } from 'interfaces/dealerLocator';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  useTheme,
} from '@mui/material';
import { Icon, Icons } from 'components/Global/Icon/Icon';
import { appPalette } from 'theme/App.palette';
import TextRender from 'components/Global/TextRender/TextRender';
import { trackEvent } from 'helpers/Analytics';
import { useStyles } from './DealerBadges.styles';

export interface IDealerBadges {
  dealer: Dealer;
}
export function DealerBadges({ dealer }: IDealerBadges) {
  const classes = useStyles();
  const theme = useTheme();
  const isHondaThemed = theme.themeName === 'honda';
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const { acura_red, honda_blue } = appPalette.colors;
  const { attributes: badges } = dealer;

  const handleChange =
    (panel: string) => (event: React.ChangeEvent<{}>, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
      trackEvent({
        label: `dealer details:${newExpanded ? 'expand' : 'collapse'} ${panel}`,
        category: {
          includePageName: false,
          text: 'locate dealer details',
        },
        type: 'selector',
        dealer: {
          dealerId: dealer.dealerNumber,
          dealerZipcode: dealer.zipCode,
          dealerName: dealer.name,
          dealerAddress: `${dealer.address}, ${dealer.city}, ${dealer.state} ${dealer.zipCode}`,
        },
      });
    };

  if (badges?.length && !isHondaThemed) {
    return (
      <Grid className="dealer-badges">
        {badges.map((badge: DealerAttribute) => {
          return (
            <Accordion
              className={`${classes.badgeContainer} ${
                expanded === badge.name ? 'is-expanded' : ''
              }`}
              square
              key={badge.name}
              expanded={expanded === badge.name}
              onChange={handleChange(badge.name)}
            >
              <AccordionSummary
                className={`${classes.badgeHeader}  t-dealer-badge`}
                aria-controls={`${badge.name}-content`}
                id={`${badge.name}-header`}
                aria-label={`${badge.name} badge information`}
              >
                {badge.iconUrl && (
                  <img
                    className={classes.badgeImage}
                    alt={badge.friendlyName}
                    src={badge.iconUrl}
                  />
                )}
                <p
                  className={`${classes.badge_title} ${
                    isHondaThemed ? 'atm-caption-6' : 'acr-paragraph-13'
                  }`}
                >
                  <TextRender text={badge.friendlyName} />
                </p>
                <Icon
                  type={
                    expanded === badge.name
                      ? Icons.circleMinus
                      : Icons.circlePlus
                  }
                  color={isHondaThemed ? honda_blue : acura_red}
                  className={classes.badgeIcon}
                />
              </AccordionSummary>
              <AccordionDetails>
                <div
                  className={`${classes.badge_description} ${
                    isHondaThemed ? 'atm-paragraph-5' : 'acr-paragraph-13'
                  }`}
                >
                  <TextRender text={badge.fullDescription} />
                </div>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Grid>
    );
  } else {
    return <></>;
  }
}
